import axios from "axios";
import React, { Component } from "react";
import cookie from "react-cookies";
import CurrencyFormat from "react-currency-format";
import "./BookTripModal.css";

import { Avatar, Badge, Drawer, Popover, Steps, Tooltip } from "antd";
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import constants from "../../Constants";
import PlacesAutocomplete from "../../components/common/PlacesAutocomplete";
import PriceView from "../../components/common/PriceView";
import util from "../../util";
const baseURL = constants.baseURL;

const tripCountLabel = (n) => {
  const count = Number(n) || 0;
  return `${count} trip${count === 1 ? "" : "s"}`;
};

const { Step } = Steps;

class Section extends Component {
  constructor(props) {
    super(props);
    console.log("props", props);
    this.state = {
      loading: false,
      success: false,
      trackYourOrder: false,
      openSuccessModal: false,
      acceptedOffer: "",
      apierror: "",
      fullQuote: {
        tripDistance: 0,
        tripDuration: 0,
        sellingPrice: 0,
        storedQuoteId: "",
      },
      viewmore: true,
      firstname: cookie.load("ctName") || "",
      lastname: "Admin",
      runners: 0,
      floors: 0,
      vehicletypes: [],
      vehiclecategories: [],
      showOtherCategories: false,
      vehicleconfigurations: {},
      openDiscountCode: false,
      expanded: [],
      currentStep: 0,
      showDateTimeTip: false,
      celebrateTopDrivers: false,
      ...props,
      prospectmobilenumber:
        props?.order?.prospectmobilenumber || props?.order?.mobilenumber,
      prospectemail: props?.order?.prospectemail || props?.order?.email,
      ...props.order,
      promocode:
        props?.order?.promocode ||
        props?.promocode ||
        cookie.load("promocode") ||
        "",
      collection: {
        lat: props?.order?.collectionlat || 0,
        lng: props?.order?.collectionlng || 0,
      },
      delivery: {
        lat: props?.order?.deliverylat || 0,
        lng: props?.order?.deliverylng || 0,
      },
    };
  }
  componentDidMount() {
    if (this.validStepOne()) {
      this.getQuote();
    } else if (this.props.driver && this.state.trucktype) {
      // Rebooking with a specific driver but some trip details are missing
      // (e.g. description, mobile, or promocode) - jump to Add Info so the
      // user can fill the gaps instead of getting stuck on Pick Vehicle.
      this.setState({ currentStep: 1 });
    }
    this.maybeCelebrateTopDrivers();
  }

  componentDidUpdate(prevProps, prevState) {
    // When the user enters the Your Quote step, briefly highlight the editable
    // date & time so they know they can change it before confirming.
    if (prevState.currentStep !== 2 && this.state.currentStep === 2) {
      if (this._dateTipTimer) clearTimeout(this._dateTipTimer);
      this.setState({ showDateTimeTip: true });
      this._dateTipTimer = setTimeout(() => {
        this.setState({ showDateTimeTip: false });
      }, 4500);
    }
    // Trigger the shake + confetti once the top drivers list populates.
    if (
      (prevProps.topDrivers?.length || 0) === 0 &&
      (this.props.topDrivers?.length || 0) > 0
    ) {
      this.maybeCelebrateTopDrivers();
    }
  }

  maybeCelebrateTopDrivers() {
    if (this._hasCelebratedTopDrivers) return;
    if (!this.props.topDrivers || this.props.topDrivers.length === 0) return;
    this._hasCelebratedTopDrivers = true;
    this._topDriversShakeTimer = setTimeout(
      () => this.setState({ celebrateTopDrivers: true }),
      250
    );
    this._topDriversShakeOffTimer = setTimeout(
      () => this.setState({ celebrateTopDrivers: false }),
      2000
    );
  }

  componentWillUnmount() {
    if (this._dateTipTimer) clearTimeout(this._dateTipTimer);
    if (this._topDriversShakeTimer) clearTimeout(this._topDriversShakeTimer);
    if (this._topDriversShakeOffTimer)
      clearTimeout(this._topDriversShakeOffTimer);
  }

  getVehicleTypes() {
    const { vehicletypes } = this.state;
    if (vehicletypes?.length === 0)
      axios.get(baseURL + "/vehicle-types").then((repos) => {
        const vehicletypesdata = repos.data;
        this.setState({
          vehicletypes: vehicletypesdata?.vehicles,
          vehiclecategories: vehicletypesdata?.categories,
          vehicleconfigurations: vehicletypesdata?.configurations,
        });
      });
  }

  changeTruck(trucktype) {
    this.setState({
      trucktype: trucktype || "",
      driver: undefined,
      quotevehicleid: undefined,
      vehicleid: undefined,
    });
  }
  validStepOne() {
    const {
      trucktype,
      description,
      delivery,
      collection,
      prospectmobilenumber,
      collectiontime,
      collectiondate,
    } = this.state;
    const fail = (field, value) => {
      console.log("[BookTripModal] validStepOne failed at:", field, "=", value);
      return false;
    };
    if (
      !prospectmobilenumber ||
      prospectmobilenumber?.length === 0 ||
      prospectmobilenumber?.length < 10
    )
      return fail("prospectmobilenumber", prospectmobilenumber);
    if (!collectiontime || collectiontime === "")
      return fail("collectiontime", collectiontime);
    if (!collectiondate || collectiondate === "")
      return fail("collectiondate", collectiondate);
    if (!description || description === "")
      return fail("description", description);
    if (!trucktype || trucktype === "") return fail("trucktype", trucktype);
    if (!delivery?.lat || delivery?.lat === 0)
      return fail("delivery.lat", delivery);
    if (!collection?.lat || collection?.lat === 0)
      return fail("collection.lat", collection);
    if (collection?.lat === delivery?.lat && collection?.lng === delivery?.lng)
      return fail("collection==delivery", { collection, delivery });
    return true;
  }
  validStepTwo() {
    const {
      firstname,
      lastname,
      email,
      mobilenumber,
      collectiondate,
      collectiontime,
      description,
    } = this.state;

    return !(
      firstname.length === 0 ||
      lastname.length === 0 ||
      email.length === 0 ||
      mobilenumber.length === 0 ||
      collectiondate.length === 0 ||
      collectiontime.length === 0 ||
      description.length === 0
    );
  }
  getQuote() {
    const {
      trucktype,
      delivery,
      collection,
      usercategory,
      runners,
      collectiondate, //required
      collectiontime, //required
      floors,
      description,
      promocode,
      duration,
      trips,
      prospectemail,
      prospectmobilenumber,
      email,
      mobilenumber,
      budget,
    } = this.state;
    if (!this.validStepOne()) return;

    this.setState({
      loading: true,
      apierror: "",
      acceptedOffer: "",
      fullQuote: {
        tripDistance: 0,
        tripDuration: 0,
        sellingPrice: 0,
        storedQuoteId: "",
        discount: "",
      },
    });
    axios
      .post(
        baseURL + "/quote",
        {
          customerid: cookie.load("localsessionid"),
          description,
          duration,
          trips,
          trucktype: trucktype,
          truckType: trucktype,
          delivery,
          promocode,
          collection,
          category: usercategory,
          runners: runners || 0,
          floors: floors || 0,
          prospectemail: prospectemail || email,
          collectiondate, //required?
          collectiontime, //required?
          prospectmobilenumber: prospectmobilenumber || mobilenumber,
          budget: budget * 100 || null,
          source_:
            util.navigator_() + util.source_() + " qtref:" + document?.referrer,
          quotevehicleid: this.state.vehicleid || this.props.vehicleid,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: cookie.load("session-id-qt"),
          },
        }
      )
      .then((response) => {
        if (response.data.sellingPrice > 0) {
          this.setState(
            {
              loading: false,
              currentStep: 2,
              fullQuote: {
                ...response.data,
                tripDistance: response.data.tripDistance,
                tripDuration: response.data.tripDuration,
                sellingPrice: response.data.sellingPrice,
                storedQuoteId: response.data.quoteId,
                discount: response.data.discount,
              },
            },
            () => {
              if (window.document.getElementById("mainquote"))
                window.document.getElementById("mainquote").scrollIntoView({
                  behavior: "smooth",
                });
            }
          );
        }
      })
      .catch((e) => {
        this.setState({
          loading: false,
          apierror: "Check your addresses or vehicle type and try again.",
        });
      });
  }
  acceptQuote() {
    this.setState({
      loading: true,
      apierror: "",
    });
    const {
      fullQuote,
      firstname,
      lastname,
      promocode,
      email,
      mobilenumber,
      collectiondate,
      collectiontime,
      description,
      acceptedOffer,
    } = this.state;

    axios
      .post(
        baseURL + "/accept-quote",
        {
          fullQuote,
          firstname,
          lastname,
          email,
          mobilenumber,
          collectiondate,
          collectiontime,
          description,
          promocode,
          acceptedOffer: acceptedOffer?.toLowerCase(),
          customerid: cookie.load("localsessionid"),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: cookie.load("session-id-qt"),
          },
        }
      )
      .then((response) => {
        this.setState(
          {
            loading: false,
            success: response.status === 200,
            openSuccessModal: false,
            orderid: response?.data?.orderid,
            currentStep: 3,
          },
          () => {
            if (response.status === 200 && response?.data?.orderid?.length > 0)
              cookie.save(
                "currentOrder",
                `email=${this.state.email}&orderid=${response.data.orderid}`,
                {
                  path: "/",
                  maxAge: 86400,
                  secure: true,
                }
              );
          }
        );
      })
      .catch((e) => {
        this.setState({
          loading: false,
          apierror: "Request failed. Please try again.",
        });
      });
  }
  vehiclePriceTip(vehicle, change) {
    function roundToNearestFifty(num) {
      return Math.round(num / 50) * 50;
    }
    let costOfDelivery =
      2000 * vehicle?.pricePerMeterCents + //cents
      1200 * vehicle?.pricePerSecondCents + //cents for 10 minutes
      vehicle?.handlingFeeCents; //cents
    let serviceFeePercentage = vehicle?.serviceFeePercentage * costOfDelivery;
    return roundToNearestFifty(
      ///hack for days /////!!!!!! needs review
      Math.round(
        ((costOfDelivery + serviceFeePercentage) * 1.15 * change || 1) / 100
      )
    );
  }
  getImage(trucktype) {
    try {
      return `https://media.qiktruck.co.za/3d-${trucktype}.png`;
    } catch (error) {
      return "";
    }
  }
  getProfileImage(photo) {
    try {
      return `https://advertsmedia.qiktruck.co.za/${photo}`;
    } catch (error) {
      return "";
    }
  }
  expandVehicleView(str) {
    let arr = [...this.state.expanded];
    let index = arr.indexOf(str);
    if (index > -1) {
      arr.splice(index, 1);
    } else {
      arr.push(str);
    }
    this.setState({ expanded: arr });
  }
  getHappyDriver(num) {
    return (
      <img
        src={"https://media.qiktruck.co.za/happydriver" + (num + 1) + ".png"}
        alt=""
        className={"happydriver"}
      />
    );
  }
  renderVehicleCategory(categoryName, filter) {
    const { vehicletypes, trucktype } = this.state;
    const filteredVehicles = vehicletypes?.filter(filter) || [];

    if (filteredVehicles.length === 0) return null;

    return (
      <div className="vehicle-category mb-4">
        <h5 className="vehicle-category-title">
          <i className="mdi mdi-truck mr-2"></i>
          {categoryName}
        </h5>
        <div className="vehicle-grid">
          {filteredVehicles.map((v, index) => {
            const image = this.getImage(v.type);
            return (
              <div
                key={index + image}
                className={`vehicle-card ${
                  trucktype === v.type ? "selected" : ""
                }`}
                onClick={() => {
                  this.changeTruck(v.type);
                  this.setState({
                    currentStep: 1,
                  });
                }}
              >
                <div className="vehicle-image">
                  <img src={image} alt={v.type} />
                </div>
                <div className="vehicle-info">
                  <h6>
                    {v.type
                      .replace("open", "")
                      .replace("closed", "")
                      .replace("andtrailer", "")
                      .trim()}
                  </h6>
                  <Popover
                    content={v.tip.drivertip}
                    title="Vehicle Details"
                    trigger="hover"
                  >
                    <span className="info-tag">
                      <i className="mdi mdi-information-outline"></i> Info
                    </span>
                  </Popover>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    this.getVehicleTypes();
    const {
      promocode,
      runners,
      floors,
      fullQuote: { discount, sellingPrice },
      loading,
      trucktype,
      collectionaddress,
      deliveryaddress,
      driver,
      currentStep,
    } = this.state;

    return this.props?.showBookTripModal === true ? (
      <>
        <Drawer
          title={
            <div className="drawer-header">
              <Steps current={currentStep} size="small" className="mt-3">
                <Step
                  title="Pick Vehicle"
                  onClick={() =>
                    currentStep > 0 && this.setState({ currentStep: 0 })
                  }
                />
                <Step
                  title="Add Info"
                  onClick={() =>
                    currentStep > 1 && this.setState({ currentStep: 1 })
                  }
                />
                <Step
                  title="Review Quote"
                  onClick={() =>
                    currentStep > 2 && this.setState({ currentStep: 2 })
                  }
                />
                <Step
                  title="Booking Complete"
                  onClick={() =>
                    currentStep === 3 && this.setState({ currentStep: 3 })
                  }
                />
              </Steps>
            </div>
          }
          placement="right"
          onClose={() => this.props?.setShowBookTripModal(false)}
          open={this.props?.showBookTripModal}
          width={"100%"}
          key="right"
          className="book-trip-drawer"
        >
          {loading && (
            <div className="loading-overlay">
              <div className="loading-content">
                <Spinner color="primary" size="lg" />
                <p>Getting your quote...</p>
              </div>
            </div>
          )}

          <div className="drawer-content">
            <div id={"pagefragmenttop"}></div>
            {/* Step 1: Vehicle Selection */}
            {currentStep === 0 && (
              <div className="step-content">
                {/* Top Active Drivers shortcut - click to rebook same route/goods with this driver */}
                {this.props.topDrivers && this.props.topDrivers.length > 0 && (
                  <div
                    className={
                      "top-drivers-shortcut" +
                      (this.state.celebrateTopDrivers
                        ? " top-drivers-shortcut-shake"
                        : "")
                    }
                    style={{ position: "relative" }}
                  >
                    {this.state.celebrateTopDrivers && (
                      <div className="top-drivers-confetti">
                        {Array.from({ length: 18 }).map((_, i) => {
                          const angle = (i / 18) * Math.PI * 2;
                          const distance = 50 + ((i * 7) % 40);
                          const colors = [
                            "#f5861f",
                            "#ffd700",
                            "#ff4d6d",
                            "#38b000",
                            "#3a86ff",
                            "#9d4edd",
                          ];
                          return (
                            <span
                              key={i}
                              className="top-drivers-confetti-piece"
                              style={{
                                background: colors[i % colors.length],
                                "--qt-dx": `${Math.cos(angle) * distance}px`,
                                "--qt-dy": `${
                                  Math.sin(angle) * distance - 10
                                }px`,
                                "--qt-rot": `${(i * 40) % 360}deg`,
                                animationDelay: `${(i % 6) * 20}ms`,
                              }}
                            />
                          );
                        })}
                      </div>
                    )}
                    <h5 className="vehicle-category-title">
                      <i
                        className="mdi mdi-account-star mr-2"
                        style={{ color: "#f5861f" }}
                      ></i>
                      Book again with one of your top drivers
                    </h5>
                    <p className="top-drivers-hint">
                      Tap a driver to auto-fill their most recent trip and jump
                      straight to your quote.
                    </p>
                    <div className="top-drivers-row">
                      {this.props.topDrivers.map((d, idx) => (
                        <Tooltip
                          key={d.vehicleid}
                          title={`${tripCountLabel(d.trips)} with ${d.firstname}. Click to rebook their latest trip.`}
                          placement="bottom"
                        >
                          <div
                            className="top-driver-card"
                            onClick={() => {
                              if (this.props.onSelectTopDriver) {
                                this.props.onSelectTopDriver(d);
                              }
                            }}
                          >
                            {idx < 3 && (
                              <div
                                className="top-driver-rank"
                                style={{
                                  background:
                                    idx === 0
                                      ? "#ffd700"
                                      : idx === 1
                                      ? "#c0c0c0"
                                      : "#cd7f32",
                                }}
                              >
                                {idx + 1}
                              </div>
                            )}
                            <img
                              src={this.getImage(d.trucktype)}
                              alt={d.trucktype}
                              className="top-driver-truck"
                            />
                            <div className="top-driver-info">
                              <div className="top-driver-name">
                                {d.firstname} {d.lastname}
                              </div>
                              <div className="top-driver-meta">
                                {tripCountLabel(d.trips)} (60d) · {d.trucktype}
                              </div>
                            </div>
                            <i className="mdi mdi-refresh top-driver-cta"></i>
                          </div>
                        </Tooltip>
                      ))}
                    </div>
                  </div>
                )}
                <div className="vehicle-selector-container">
                  {this.renderVehicleCategory(
                    "Open Vehicles",
                    (v) =>
                      v.type.indexOf("closed") === -1 &&
                      v.type.indexOf("bike") === -1 &&
                      v.type.indexOf("tipper") === -1
                  )}

                  {this.renderVehicleCategory(
                    "Closed Vehicles",
                    (v) =>
                      v.type.indexOf("open") === -1 &&
                      v.type.indexOf("bike") === -1 &&
                      v.type.indexOf("tipper") === -1 &&
                      v.type.indexOf("fridge") === -1
                  )}

                  {this.renderVehicleCategory(
                    "Refrigerated Vehicles",
                    (v) => v.type.indexOf("fridge") > -1
                  )}
                </div>

                <div className="action-bar">
                  <Button
                    className="action-button primary"
                    onClick={() => {
                      this.setState({ currentStep: 1 });
                      //scroll to top of drawer
                    }}
                    disabled={!trucktype}
                  >
                    <i className="mdi mdi-arrow-right mr-2"></i>
                    Continue
                  </Button>
                </div>
              </div>
            )}

            {/* Step 2: Trip Details */}
            {currentStep === 1 && (
              <div className="step-content">
                <div className="section-header">
                  <i className="mdi mdi-map-marker-path"></i>
                  <h4>Trip Details</h4>
                </div>

                <div className="selected-vehicle-summary clickable" onClick={() => {
                  this.setState({
                    currentStep: 0,
                  });
                }}>
                  <img src={this.getImage(trucktype)} alt={trucktype} />
                  <div className="vehicle-name">
                    <h5>
                      {trucktype
                        .replace("open", "")
                        .replace("closed", "")
                        .replace("andtrailer", "")
                        .trim()}
                    </h5>
                    <span>Selected Vehicle</span>
                  </div>
                </div>

                <Row className="address-section">
                  <Col md={6}>
                    <FormGroup>
                      <Label className="font-18">Collection Address</Label>
                      <PlacesAutocomplete
                        type="text"
                        className="form-control enhanced-input"
                        id="collection"
                        placeholder={
                          collectionaddress || "Enter collection address"
                        }
                        required
                        autoComplete="new-password"
                        onPlaceSelected={(place) => {
                          this.setState({
                            collection: {
                              lat: place?.geometry?.location?.lat(),
                              lng: place?.geometry?.location?.lng(),
                            },
                          });
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label className="font-18">Delivery Address</Label>
                      <PlacesAutocomplete
                        type="text"
                        className="form-control enhanced-input"
                        id="delivery"
                        placeholder={
                          deliveryaddress || "Enter delivery address"
                        }
                        required
                        autoComplete="new-password"
                        onPlaceSelected={(place) => {
                          this.setState({
                            delivery: {
                              lat: place?.geometry?.location?.lat(),
                              lng: place?.geometry?.location?.lng(),
                            },
                          });
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label className="font-18">Collection Date</Label>
                      <Input
                        id="collectiondate1"
                        name="collectiondate1"
                        placeholder="Collection date"
                        defaultValue={this.state.collectiondate}
                        type="date"
                        onChange={(e) => {
                          this.setState({
                            collectiondate: e.target.value,
                          });
                        }}
                        className="enhanced-input"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label className="font-18">Collection Time</Label>
                      <Input
                        id="collectiontime1"
                        name="collectiontime1"
                        defaultValue={this.state.collectiontime}
                        placeholder="Time"
                        type="time"
                        onChange={(e) => {
                          this.setState({
                            collectiontime: e.target.value,
                          });
                        }}
                        className="enhanced-input"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label className="font-18">Description</Label>
                      <Input
                        id="description"
                        name="text"
                        type="textarea"
                        defaultValue={this.state.description}
                        rows={4}
                        placeholder="Provide details about what you are moving..."
                        onChange={(e) => {
                          this.setState({ description: e.target.value });
                        }}
                        className="enhanced-input"
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <div className="section-header">
                  <i className="mdi mdi-account-details"></i>
                  <h4>Contact Information</h4>
                </div>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label className="font-18">Mobile Number</Label>
                      <Input
                        id="prospectmobilenumber"
                        name="prospectmobilenumber"
                        placeholder="Mobile number (e.g. 0821234567)"
                        minLength={10}
                        defaultValue={
                          this.state.prospectmobilenumber ||
                          this.state.mobilenumber
                        }
                        onChange={(e) => {
                          this.setState({
                            prospectmobilenumber: e.target.value,
                            mobilenumber: e.target.value,
                            mobilenumbererror:
                              e.target.value.length < 10 ||
                              /^\d+$/.exec(e.target.value) === null,
                          });
                        }}
                        className={`enhanced-input ${
                          this.state.mobilenumbererror ? "is-invalid" : ""
                        }`}
                      />
                      {this.state.mobilenumbererror && (
                        <div className="invalid-feedback">
                          Valid mobile number is required
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label className="font-18">Email Address</Label>
                      <Input
                        id="prospectemail"
                        name="prospectemail"
                        placeholder="Email address"
                        defaultValue={
                          this.state.prospectemail || this.state.email
                        }
                        onChange={(e) => {
                          this.setState({
                            prospectemail: e.target.value,
                            email: e.target.value,
                          });
                        }}
                        className="enhanced-input"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <div
                  className="additional-options"
                  onClick={() => this.setState({ openDiscountCode: true })}
                >
                  <div className="options-icon">
                    <i className="mdi mdi-tag-multiple"></i>
                  </div>
                  <div className="options-details">
                    <h5>Additional Options</h5>
                    <p>
                      {floors} Floor{floors === 1 ? "" : "s"}, {runners} Helper
                      {runners === 1 ? "" : "s"}
                      {promocode?.length > 0 && `, Discount: ${promocode}`}
                    </p>
                  </div>
                  <i className="mdi mdi-chevron-right options-arrow"></i>
                </div>

                {(!this.state?.collection?.lat ||
                  !this.state?.delivery?.lng) && (
                  <div className="alert-custom warning">
                    <i className="mdi mdi-alert-circle-outline mr-2"></i>
                    Please select collection and delivery addresses
                  </div>
                )}

                {this.state.loading === false &&
                  this.state.apierror.length > 0 && (
                    <div className="alert-custom error">
                      <i className="mdi mdi-close-circle-outline mr-2"></i>
                      {this.state.apierror}
                    </div>
                  )}

                <div className="action-bar">
                  <Button
                    className="action-button secondary"
                    onClick={() => {
                      this.setState({ currentStep: 0 });
                    }}
                  >
                    <i className="mdi mdi-arrow-left mr-2"></i>
                    Back
                  </Button>
                  <Button
                    className="action-button primary"
                    onClick={() => {
                      this.getQuote();
                    }}
                    disabled={!this.validStepOne() || loading}
                  >
                    <i className="mdi mdi-calculator-variant mr-2"></i>
                    Get Quote
                  </Button>
                </div>
              </div>
            )}

            {/* Step 3: Quote Review */}
            {currentStep === 2 && (
              <div className="step-content" id={"mainquote"}>
                <div className="section-header">
                  <i className="mdi mdi-receipt"></i>
                  <h4>Your Quote</h4>
                </div>
                <div className="vehicle-details">
                  <div className="trip-metrics">
                    <div className="metric">
                      <i className="mdi mdi-map-marker-distance"></i>
                      <span>
                        {Math.round(this.state.fullQuote.tripDistance / 1000)}{" "}
                        km
                      </span>
                    </div>
                    <div className="metric">
                      <i className="mdi mdi-clock-outline"></i>
                      <span>
                        {Math.round(this.state.fullQuote.tripDuration / 60)}{" "}
                        minutes
                      </span>
                    </div>
                  </div>
                </div>
                <div className="quote-summary">
                  <div className="vehicle-summary ">
                    <div className="summary-content">
                      <div className="summary-item">
                        <div className="summary-label">
                          <i className="mdi mdi-truck"></i>
                          <span>Vehicle</span>
                        </div>
                        <div className="summary-value">
                          {trucktype
                            .replace("open", "")
                            .replace("closed", "")
                            .replace("andtrailer", "")
                            .trim()}
                        </div>
                      </div>

                      <div className="summary-item">
                        <div className="summary-label">
                          <i className="mdi mdi-map-marker"></i>
                          <span>Collection</span>
                        </div>
                        <div className="summary-value">
                          {this.state.collectionaddress}
                        </div>
                      </div>

                      <div className="summary-item">
                        <div className="summary-label">
                          <i className="mdi mdi-map-marker-check"></i>
                          <span>Delivery</span>
                        </div>
                        <div className="summary-value">
                          {this.state.deliveryaddress}
                        </div>
                      </div>

                      <Tooltip
                        title="You can still edit the pickup date & time here before confirming the booking"
                        open={this.state.showDateTimeTip}
                        placement="top"
                        color="#f5861f"
                      >
                        <div className="summary-item">
                          <div className="summary-label">
                            <i className="mdi mdi-calendar"></i>
                            <span>Date & Time</span>
                          </div>
                          <div className="summary-value summary-value-edit">
                            <Input
                              type="date"
                              value={this.state.collectiondate || ""}
                              onChange={(e) =>
                                this.setState({
                                  collectiondate: e.target.value,
                                  showDateTimeTip: false,
                                })
                              }
                              className="inline-edit-input"
                              bsSize="sm"
                            />
                            <Input
                              type="time"
                              value={this.state.collectiontime || ""}
                              onChange={(e) =>
                                this.setState({
                                  collectiontime: e.target.value,
                                  showDateTimeTip: false,
                                })
                              }
                              className="inline-edit-input"
                              bsSize="sm"
                            />
                          </div>
                        </div>
                      </Tooltip>

                      <div className="summary-item">
                        <div className="summary-label">
                          <i className="mdi mdi-text-box"></i>
                          <span>Description</span>
                        </div>
                        <div className="summary-value description-text">
                          {this.state.description}
                        </div>
                      </div>

                      <div className="summary-item">
                        <div className="summary-label">
                          <i className="mdi mdi-account"></i>
                          <span>Contact</span>
                        </div>
                        <div className="summary-value">
                          {this.state.prospectmobilenumber} |{" "}
                          {this.state.prospectemail}
                        </div>
                      </div>

                      <div className="summary-item">
                        <div className="summary-label">
                          <i className="mdi mdi-tune"></i>
                          <span>Additional</span>
                        </div>
                        <div className="summary-value">
                          {this.state.floors} Floor
                          {this.state.floors === 1 ? "" : "s"},
                          {this.state.runners} Helper
                          {this.state.runners === 1 ? "" : "s"}
                          {this.state.promocode?.length > 0 &&
                            `, Promo: ${this.state.promocode}`}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="price-display">
                    {driver && (
                      <div className="quote-driver-profile">
                        <Avatar
                          size={48}
                          style={{ background: "#f5861f", flexShrink: 0 }}
                          icon={<i className="mdi mdi-account"></i>}
                        />
                        <div className="quote-driver-body">
                          <div className="quote-driver-label">
                            <i
                              className="mdi mdi-star"
                              style={{ color: "#FFD700" }}
                            ></i>{" "}
                            Your driver
                          </div>
                          <div className="quote-driver-name">
                            {driver.firstname}{" "}
                            {driver.lastname
                              ? driver.lastname.slice(0, 1) + "."
                              : ""}
                          </div>
                          <div className="quote-driver-meta">
                            {driver.trucktype}
                            {driver.city ? " · " + driver.city : ""}
                            {driver.trips
                              ? " · " + tripCountLabel(driver.trips) + " (60d)"
                              : ""}
                          </div>
                        </div>
                      </div>
                    )}
                    <PriceView
                      sellingPrice={sellingPrice || 0}
                      discount={discount}
                      loading={loading}
                      disabled={
                        typeof sellingPrice === "undefined" ||
                        sellingPrice === null ||
                        sellingPrice === 0 ||
                        loading
                      }
                      trucktype={trucktype}
                      showButton={false}
                      acceptOffer={() => {
                        console.log("acceptOffer");
                        this.setState(
                          { acceptedOffer: "sellingPrice", currentStep: 3 },
                          () => {
                            if (window.document.getElementById("makebooking"))
                              window.document
                                .getElementById("makebooking")
                                .scrollIntoView({ behavior: "smooth" });
                          }
                        );
                      }}
                    />
                  </div>
                </div>

                {/* Other Vehicle Price Options */}
                {this.state.fullQuote.otherOptions?.filter(
                  (o) => o.sellingPrice > 0
                )?.length > 0 && (
                  <div style={{ margin: "16px 0" }}>
                    <h6 style={{ textAlign: "center", color: "#888", marginBottom: 8 }}>
                      Other vehicle options
                    </h6>
                    <div
                      className="d-flex flex-row overflow-auto pb-2"
                      style={{ gap: 10, WebkitOverflowScrolling: "touch" }}
                    >
                      {this.state.fullQuote.otherOptions
                        .filter((o) => o.sellingPrice > 0)
                        .map((option, index) => {
                          const isSelected = trucktype === option.truckType;
                          return (
                          <div
                            key={index}
                            ref={(el) => {
                              if (
                                el &&
                                isSelected &&
                                this._lastScrolledTruckType !== option.truckType
                              ) {
                                this._lastScrolledTruckType = option.truckType;
                                try {
                                  el.scrollIntoView({
                                    behavior: "smooth",
                                    block: "nearest",
                                    inline: "center",
                                  });
                                } catch (e) {
                                  // older browsers
                                  el.scrollIntoView();
                                }
                              }
                            }}
                            className="card flex-shrink-0 p-2"
                            style={{
                              width: 140,
                              minWidth: 140,
                              cursor: "pointer",
                              border: isSelected
                                ? "2px solid #f5861f"
                                : "1px solid #dee2e6",
                            }}
                            onClick={() => {
                              this.setState(
                                { trucktype: option.truckType },
                                () => this.getQuote()
                              );
                            }}
                          >
                            <div className="text-center">
                              <img
                                src={this.getImage(option.truckType)}
                                alt={option.truckType}
                                style={{ height: 40, objectFit: "contain" }}
                              />
                              <div
                                className="mt-1 text-capitalize text-truncate"
                                style={{ fontSize: 12 }}
                              >
                                {option.truckType
                                  ?.replace("open", "")
                                  ?.replace("closed", "")}
                              </div>
                              <div style={{ fontWeight: "bold", color: "#f5861f" }}>
                                <CurrencyFormat
                                  value={option.sellingPrice / 100}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"R"}
                                  decimalScale={0}
                                />
                              </div>
                            </div>
                          </div>
                          );
                        })}
                    </div>
                  </div>
                )}

                <div className="action-bar">
                  <Button
                    className="action-button secondary"
                    onClick={() => {
                      this.setState({ currentStep: 1 });
                    }}
                  >
                    <i className="mdi mdi-arrow-left mr-2"></i>
                    Back
                  </Button>
                  <Button
                    className="action-button secondary"
                    onClick={() => {
                      this.setState({
                        loading: true,
                        emailQuotation: false,
                      });
                      let quote = this.state.fullQuote;
                      axios
                        .post(
                          baseURL + "/customer-quotation-document",
                          {
                            quoteid: quote?.storedQuoteId,
                          },
                          {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization: cookie.load("session-id-qt"),
                            },
                          }
                        )
                        .then((res) => {
                          this.setState({
                            loading: false,
                            emailQuotation: true,
                          });
                        })
                        .catch((err) => {
                          this.setState({ loading: false });
                        });
                    }}
                    disabled={
                      !this.state.fullQuote?.storedQuoteId || this.state.loading
                    }
                  >
                    <i className="mdi mdi-email mr-2"></i>
                    Email Me Quotation PDF
                  </Button>
                  <Button
                    className="action-button primary"
                    onClick={() => {
                      this.setState({ acceptedOffer: "sellingPrice" }, () =>
                        this.acceptQuote()
                      );
                    }}
                    disabled={
                      !this.state.fullQuote?.storedQuoteId || this.state.loading
                    }
                  >
                    <i className="mdi mdi-check-circle-outline mr-2"></i>
                    Accept Quote
                  </Button>
                </div>
              </div>
            )}

            {/* Step 4: Booking Complete - Only shown after successful booking */}
            {currentStep === 3 && this.state.success && (
              <div className="step-content">
                <div className="success-header">
                  <div className="success-icon">
                    <i className="mdi mdi-check"></i>
                  </div>
                  <h4>Order Successful!</h4>
                </div>

                <div className="success-message">
                  <i className="mdi mdi-truck-check"></i>
                  <p>
                    Your booking has been successfully received. Here's what
                    happens next:
                  </p>
                </div>

                <ListGroup className="success-steps">
                  <ListGroupItem>
                    <div className="step-number">1</div>
                    <div className="step-content">
                      <h5>Driver Contact</h5>
                      <p>
                        A driver will be in touch shortly to confirm your order
                      </p>
                    </div>
                  </ListGroupItem>

                  <ListGroupItem>
                    <div className="step-number">2</div>
                    <div className="step-content">
                      <h5>Invoice Email</h5>
                      <p>You will receive an email with your invoice shortly</p>
                    </div>
                  </ListGroupItem>

                  <ListGroupItem>
                    <div className="step-number">3</div>
                    <div className="step-content">
                      <h5>Payment Options</h5>
                      <p>You can pay now or after the delivery is completed</p>
                    </div>
                  </ListGroupItem>

                  <ListGroupItem>
                    <div className="step-number">4</div>
                    <div className="step-content">
                      <h5>ID Verification</h5>
                      <p>Have your ID ready when the driver arrives</p>
                    </div>
                  </ListGroupItem>
                </ListGroup>

                <div className="order-id-book-trip">
                  <span>Order Reference:</span>
                  <Badge color="primary">{this.state.orderid}</Badge>
                </div>

                <div className="action-bar">
                  <Button
                    className="action-button primary"
                    onClick={() => {
                      this.setState(
                        {
                          trackYourOrder: true,
                        },
                        () => {
                          window.location.reload();
                        }
                      );
                    }}
                  >
                    <i className="mdi mdi-check mr-2"></i>
                    Done
                  </Button>
                </div>
              </div>
            )}
          </div>
        </Drawer>

        <Modal
          isOpen={
            this.state.success &&
            this.state.openSuccessModal &&
            currentStep !== 3
          }
          className="success-modal"
        >
          <ModalHeader>
            <div className="success-header">
              <div className="success-icon">
                <i className="mdi mdi-check"></i>
              </div>
              <h4>Order Successful!</h4>
            </div>
          </ModalHeader>
          <ModalBody>
            <div className="success-message">
              <i className="mdi mdi-truck-check"></i>
              <p>
                Your booking has been successfully received. Here's what happens
                next:
              </p>
            </div>

            <ListGroup className="success-steps">
              <ListGroupItem>
                <div className="step-number">1</div>
                <div className="step-content">
                  <h5>Driver Contact</h5>
                  <p>A driver will be in touch shortly to confirm your order</p>
                </div>
              </ListGroupItem>

              <ListGroupItem>
                <div className="step-number">2</div>
                <div className="step-content">
                  <h5>Invoice Email</h5>
                  <p>You will receive an email with your invoice shortly</p>
                </div>
              </ListGroupItem>

              <ListGroupItem>
                <div className="step-number">3</div>
                <div className="step-content">
                  <h5>Payment Options</h5>
                  <p>You can pay now or after the delivery is completed</p>
                </div>
              </ListGroupItem>

              <ListGroupItem>
                <div className="step-number">4</div>
                <div className="step-content">
                  <h5>ID Verification</h5>
                  <p>Have your ID ready when the driver arrives</p>
                </div>
              </ListGroupItem>
            </ListGroup>

            <div className="order-id-book-trip">
              <span>Order Reference:</span>
              <Badge color="primary">{this.state.orderid}</Badge>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              className="close-button"
              onClick={() =>
                this.setState(
                  {
                    openSuccessModal: false,
                    trackYourOrder: true,
                  },
                  () => {
                    window.location.reload();
                  }
                )
              }
            >
              <i className="mdi mdi-check mr-2"></i>
              Done
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.openDiscountCode} className="options-modal" style={{ width: "500px" }}>
          <ModalHeader>
            <div className="modal-custom-header">
              <div className="header-icon">
                <i className="mdi mdi-tune"></i>
              </div>
              <h4>Additional Options</h4>
            </div>
          </ModalHeader>
          <ModalBody>
            <div className="option-section">
              <div className="option-header">
                <i className="mdi mdi-account-multiple"></i>
                <h5>Helpers</h5>
              </div>
              <p className="option-description">
                How many people do you need to help carry and load goods? Note
                that the driver may not be able to help.
              </p>
              <div className="option-control">
                <Button
                  className="quantity-button"
                  disabled={runners <= 0}
                  onClick={() =>
                    this.setState({ runners: Math.max(0, runners - 1) })
                  }
                >
                  <i className="mdi mdi-minus"></i>
                </Button>
                <Input
                  id="runners"
                  name="runners"
                  type="number"
                  value={runners}
                  min={0}
                  className="quantity-input"
                  onChange={(e) => {
                    this.setState({ runners: parseInt(e.target.value, 10) });
                  }}
                />
                <Button
                  className="quantity-button"
                  onClick={() => this.setState({ runners: runners + 1 })}
                >
                  <i className="mdi mdi-plus"></i>
                </Button>
              </div>
            </div>

            <div className="option-section">
              <div className="option-header">
                <i className="mdi mdi-stairs"></i>
                <h5>Floors</h5>
              </div>
              <p className="option-description">
                How many floors will items need to be carried? Add more details
                in your description if needed.
              </p>
              <div className="option-control">
                <Button
                  className="quantity-button"
                  disabled={floors <= 0}
                  onClick={() =>
                    this.setState({ floors: Math.max(0, floors - 1) })
                  }
                >
                  <i className="mdi mdi-minus"></i>
                </Button>
                <Input
                  id="floors"
                  name="floors"
                  type="number"
                  value={floors}
                  min={0}
                  className="quantity-input"
                  onChange={(e) => {
                    this.setState({ floors: parseInt(e.target.value, 10) });
                  }}
                />
                <Button
                  className="quantity-button"
                  onClick={() => this.setState({ floors: floors + 1 })}
                >
                  <i className="mdi mdi-plus"></i>
                </Button>
              </div>
            </div>

            <div className="option-section">
              <div className="option-header">
                <i className="mdi mdi-tag-outline"></i>
                <h5>Discount Code</h5>
              </div>
              <p className="option-description">
                Apply a discount code to save up to 30% off your booking!
              </p>
              <Input
                id="promocode"
                name="promocode"
                type="text"
                value={promocode}
                placeholder="Enter your discount code"
                className="discount-input"
                onChange={(e) => {
                  this.setState({ promocode: e.target.value.toUpperCase() });
                }}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              className="cancel-btn"
              onClick={() => {
                this.setState({
                  openDiscountCode: false,
                });
              }}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              className="apply-btn"
              onClick={() => {
                this.getQuote();
                this.setState({
                  openDiscountCode: false,
                });
              }}
            >
              <i className="mdi mdi-check mr-2"></i>
              Apply
            </Button>
          </ModalFooter>
        </Modal>
      </>
    ) : (
      <div />
    );
  }
}

export default Section;
